export default "__VITE_ASSET__J12BXNymBmaPDkbkABZ18w__"